import { useState, useEffect, useContext } from "react"
import { Link } from "react-router-dom"
import { UserContext } from "../../../contexts/UserContext"
import "./navbarLinks.css"

export function NavbarLinks() {
    const [navLinksDisplay, setNavLinksDisplay] = useState(false)

    const userContextData = useContext(UserContext)
    const { user } = userContextData

    return (
        <>
            <i className="fa-solid fa-bars position-absolute nav-toggle lg-off cntr"
                onClick={() => setNavLinksDisplay(!navLinksDisplay)}>
            </i>

            <div className={`nav-links d-flex gap-5 ${navLinksDisplay ? "on" : ""}`}>
                <i className="fa-solid fa-x nav-toggle lg-off" onClick={() => setNavLinksDisplay(false)}></i>
                <Link to="/">Home</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/about">About</Link>
                <Link to={user ? "/" : "/login"}>Log in</Link>
            </div>
        </>
    )
}